import { Badge } from "@mantine/core";

interface VerificationStatusBadgeProps {
  status: string;
}

export default function VerificationStatusBadge({ status }: VerificationStatusBadgeProps) {
  switch (status) {
    case "VERIFIED":
      return (
        <Badge
          variant="light"
          size="lg"
          radius="sm"
          fz="xs"
          styles={{
            root: {
              backgroundColor: "#D1FAE5",
              color: "#059669",
              fontWeight: 400,
              textTransform: "none",
              padding: "4px 12px",
            },
          }}
        >
          Verified
        </Badge>
      );
    case "UNDER_REVIEW":
      return (
        <Badge
          variant="light"
          size="md"
          radius="sm"
          fz="xs"
          styles={{
            root: {
              backgroundColor: "#FEF3C7",
              color: "#D97706",
              fontWeight: 400,
              textTransform: "none",
              padding: "4px 12px",
            },
          }}
        >
          Under Verification
        </Badge>
      );
    case "ACTION_REQUIRED":
      return (
        <Badge
          variant="light"
          size="lg"
          radius="sm"
          fz="xs"
          styles={{
            root: {
              backgroundColor: "#FEE2E2",
              color: "#DC2626",
              fontWeight: 400,
              textTransform: "none",
              padding: "4px 12px",
            },
          }}
        >
          Rejected
        </Badge>
      );
    case "DRAFT":
      return (
        <Badge
          variant="light"
          size="md"
          radius="sm"
          fz="xs"
          styles={{
            root: {
              backgroundColor: "#DBEAFE",
              color: "#2563EB",
              fontWeight: 400,
              textTransform: "none",
              padding: "4px 12px",
            },
          }}
        >
          Draft
        </Badge>
      );
    case "SYSTEM_VERIFIED":
      return (
        <Badge
          variant="light"
          size="md"
          radius="sm"
          fz="xs"
          styles={{
            root: {
              backgroundColor: "#EDE9FE",
              color: "#7C3AED",
              fontWeight: 400,
              textTransform: "none",
              padding: "4px 12px",
            },
          }}
        >
          System Verified
        </Badge>
      );
    default:
      return (
        <Badge
          variant="light"
          size="md"
          radius="sm"
          fz="xs"
          styles={{
            root: {
              backgroundColor: "#F3F4F6",
              color: "#6B7280",
              fontWeight: 400,
              textTransform: "none",
              padding: "4px 12px",
            },
          }}
        >
          Unknown
        </Badge>
      );
  }
}
